/**
 * Formularfehler der Energie-Blätter (Zähler anlegen/bearbeiten, Tausch,
 * Liefervertrag): ein 422 mit `field` an einem gezeigten Feld steht dort, alles
 * andere als allgemeiner Hinweis im Blatt. Zuvor dreimal fast gleich nachgebaut
 * (`MeterSheet`, `MeterReplaceSheet`, `SupplyContractSheet`).
 */

import type { FieldError } from '@/components/FormField'
import { ApiError } from '@/lib/api'

export interface ErrorState {
  readonly field?: FieldError
  readonly general?: string
}

/** `shownFields`: Felder, die das Blatt zeigt; ohne Angabe gilt jedes `field`. */
export function toErrorState(error: unknown, shownFields?: ReadonlySet<string>): ErrorState {
  if (
    error instanceof ApiError &&
    error.status === 422 &&
    error.field !== null &&
    (shownFields === undefined || shownFields.has(error.field))
  ) {
    return { field: { field: error.field, message: error.message } }
  }
  return { general: error instanceof ApiError ? error.message : 'Die Verbindung zum Server ist unterbrochen.' }
}
